import { render } from "./index.vue?vue&type=template&id=c059a466&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&id=c059a466&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c059a466"]])

export default __exports__